import { Vue } from "vue-property-decorator";
import PageApp from './app.vue';
import 'bootstrap';

Vue.config.devtools = process.env.NODE_ENV === "development";

export default {    
    run: function(config, model) {
        Vue.prototype.$model = model;
        Vue.prototype.$mediaType = config.mediaType;

        return new Vue({
            render: (h) => h(PageApp),                  
        }).$mount("#page-app"); 
    }
}

